/* import __COLOCATED_TEMPLATE__ from './feature-upgrade-arrow-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();